import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";
import { Div } from "components/Base";
import { getters, actions } from "Portal/NewPortal/FollowupForm/model";
import Logo from "Portal/NewPortal/FollowupForm/View/Logo";
import CloseAt from "./CloseAt";
import ContactPage from "Portal/NewPortal/FollowupForm/View/ContactPage";
import Loading from "ui-kit/Loading";
import MediaQuery from "react-responsive";
import PoweredbyLennd from "components/PortalV2/PoweredbyLennd";
import { getPageTitle } from "Portal/NewPortal/FollowupForm/selectors";
import { AppBar, Toolbar } from "@material-ui/core";
import MobileFooter from "Portal/NewPortal/FollowupForm/View/Footer";
import EditingSession from "./EditingSession";
import styles from "./styles.scss";
import CSSModules from "react-css-modules";
import cx from "classnames";
import { Style } from "react-style-tag";
import { getCssCode } from "../selectors";

const Mobile = props => <MediaQuery {...props} maxWidth={820} />;
const Default = props => <MediaQuery {...props} minWidth={821} />;

const decorate = R.compose(
  withRouter,
  CSSModules(styles),
  connect(
    state => ({
      isLoggedIn: getters.isLoggedIn(state),
      activeIndex: getters.activeIndex(state),
      formData: getters.formData(state),
      loading: getters.loading(state),
      pageTitle: getPageTitle(state),
      cssCode: getCssCode(state)
    }),
    {
      goToPortalHome: actions.goToPortalHome
    }
  )
);

const Pages = ({
  handlers,
  activeIndex,
  formData,
  mobile = true,
  goToPortalHome
}) => {
  const lastSection = R.last(R.pathOr([], ["sections"], formData));
  const description = R.pathOr("", ["description"], lastSection);
  const title = R.pathOr("", ["title"], lastSection);

  return (
    <Div
      display="column.center.center"
      style={{
        gap: "20px",
        width: "100%",
        padding: "0 20px",
        backgroud: "blue"
      }}
    >
      <Div display="column.center.center">
        <Logo />
      </Div>
      <div
        className={cx(styles.container, {
          [styles.desktopContainer]: !mobile
        })}
      >
        <div className={styles.titleDescriptionContainer}>
          <div
            className={styles.breadcrumbContainer}
            onClick={() => goToPortalHome(formData)}
          >
            <i className={cx("material-icons-outlined", styles.arrowBackIcon)}>
              arrow_back
            </i>
            <div className={styles.breadcrumb}> Back to Homepage</div>
          </div>
          {title && title.length && <div className={styles.title}>{title}</div>}
          {description && description.length && (
            <span
              dangerouslySetInnerHTML={{
                __html: description
              }}
              className={styles.description}
            />
          )}
        </div>
        <CloseAt />
        <EditingSession />
        {activeIndex === 2 && <ContactPage handlers={handlers} />}
      </div>
    </Div>
  );
};

const Layout = ({
  handlers,
  activeIndex,
  formData,
  loading,
  pageTitle,
  goToPortalHome,
  cssCode
}) => {
  if (loading) {
    return <Loading height={800} />;
  }
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{pageTitle}</title>
      </Helmet>
      {cssCode ? <Style>{cssCode}</Style> : null}
      <Div bg="white" display="column.flex-start.center" height={1}>
        <AppBar position="fixed" style={{ backgroundColor: "white" }}>
          <Toolbar
            style={{
              display: "flex",
              padding: "12px 24px",
              height: "54px",
              minHeight: "54px",
              justifyContent: "space-between"
            }}
          >
            <Logo header />
          </Toolbar>
        </AppBar>
        <Mobile
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "100%",
            width: "100%"
          }}
        >
          <Div
            style={{
              backgroundImage: R.propOr("", "background_image_url", formData)
                ? `url("${R.propOr("", "background_image_url", formData)}")`
                : "inherit",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
              position: "static",
              width: "100%",
              height: "200px",
              minHeight: "200px",
              marginTop: "54px"
            }}
            height={330}
            width={1}
          />
          <div
            style={{
              position: "relative",
              height: "100%",
              margin: "-30px 0px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%"
            }}
          >
            <Pages
              handlers={handlers}
              activeIndex={activeIndex}
              loading={loading}
              formData={formData}
              mobile={true}
              goToPortalHome={goToPortalHome}
            />
          </div>
        </Mobile>
        <Default
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "100%",
            width: "100%"
          }}
        >
          <Div
            style={{
              backgroundImage: R.propOr("", "background_image_url", formData)
                ? `url("${R.propOr("", "background_image_url", formData)}")`
                : "inherit",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
              position: "static",
              width: "100%",
              height: "200px",
              minHeight: "200px",
              marginTop: "54px"
            }}
            height={330}
            width={1}
          />
          <div
            style={{
              position: "relative",
              height: "100%",
              margin: "-30px 0px 30px 0",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "820px"
            }}
          >
            <Pages
              handlers={handlers}
              activeIndex={activeIndex}
              loading={loading}
              formData={formData}
              mobile={false}
              goToPortalHome={goToPortalHome}
            />
          </div>
          <PoweredbyLennd
            style={{
              margin: "20px 0"
            }}
          />
        </Default>
        <Mobile>
          <MobileFooter handlers={handlers} disableShowAlert={false} />
        </Mobile>
      </Div>
    </>
  );
};

export default decorate(Layout);
